import { getFormattedFinance } from 'partner360/helpers/getFormattedFinance'

export enum PercentType {
  Pt = 'pt.',
  Percent = '%',
}

export const getSobPercent = (
  value: number | null | undefined,
  type: PercentType = PercentType.Percent
) => {
  if (value === null || value === undefined) {
    return '-'
  }

  return `${getFormattedFinance(value, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  })}${type}`
}
